(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/services/assets/actions/highscore-result-actions.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/services/assets/actions/highscore-result-actions.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _RTK = RTK,
  createAsyncThunk = _RTK.createAsyncThunk;
const jupiter = svs.core.jupiter;
const normalizeCompetitionResults = svs.components.marketplaceCompetition.services.helpers.normalizeCompetitionResults;
const HighscoreListType = svs.components.marketplaceCompetition.services.constants.highscoreConstants.HighscoreListType;
const CompetitionType = svs.components.marketplaceCompetition.constants.CompetitionType;
const parseCsv = children => {
  const childSplit = ',';
  const pairSplit = ';';
  const csvChildren = children.filter(_ref => {
    let _ref2 = _slicedToArray(_ref, 1),
      key = _ref2[0];
    return Boolean(key);
  }).map(keyvalue => keyvalue.join(pairSplit));
  return csvChildren.join(childSplit);
};
const fetchCompetitionHighscore = createAsyncThunk('competition/fetchCompetitionHighscore', _ref3 => {
  let competitionId = _ref3.competitionId,
    payloadType = _ref3.payloadType,
    count = _ref3.count,
    offset = _ref3.offset,
    location = _ref3.location,
    search = _ref3.search,
    _ref3$type = _ref3.type,
    type = _ref3$type === void 0 ? CompetitionType.TipsSM : _ref3$type;
  return new Promise((resolve, reject) => {
    const query = new URLSearchParams();
    query.set('ctx', 'competition');
    query.set('type', type.toLowerCase()); 
    query.set('andfilter', parseCsv([['payload.competitionForm', payloadType === HighscoreListType.Team ? 'Team' : 'Individual'], ['payload.competitionId', competitionId], location && location.length > 0 ? ['payload.location', location] : []]));
    query.set('count', count);
    query.set('offset', offset);
    query.set('operator', 'and');
    query.set('sort', parseCsv([['payload.position', 'asc']]));
    if (search && search.length > 0) {
      query.set('q', search);
    }
    jupiter.get("/search/1/query?".concat(query.toString()), response => {
      resolve(normalizeCompetitionResults(response));
    }, error => {
      reject(error);
    });
  });
});
setGlobal('svs.components.marketplaceCompetition.services.actions.highscoreResultActions', {
  fetchCompetitionHighscore
});

 })(window);